import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitFilterMandatoryStatus = createSelector(
  [selectFinancialCockpitState],
  ({ filter }) => filter.mandatoryStatus
)
